// Don't change this file manually, it will be overwritten by the build process!
export const __DEBUG_INFO_ENABLED__ = false;
export const __VERSION__ = '8.3.4';
// The root URL for API calls, ending with a '/' - for example: `"https://www.jhipster.tech:8081/myservice/"`.
// If you use an API server, in `prod` mode, you will need to enable CORS
// (see the `jhipster.cors` common JHipster property in the `application-*.yml` configurations)
export const I18N_HASH = '71761f108149b728d5e8cf72ac47ad7e';
